import React from 'react';
import { createRoot } from 'react-dom/client';
import '../scss/carte-des-investissements.scss';
import {CarteDesInvestissements} from "./widgets/CarteDesInvestissements";

export function widget(props) {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<CarteDesInvestissements {...props} />);
}
